/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceOrganizationSchema
 */
export interface WorkspaceOrganizationSchema {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceOrganizationSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceOrganizationSchema
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceOrganizationSchema
     */
    isPersonal: boolean;
}

/**
 * Check if a given object implements the WorkspaceOrganizationSchema interface.
 */
export function instanceOfWorkspaceOrganizationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isPersonal" in value;

    return isInstance;
}

export function WorkspaceOrganizationSchemaFromJSON(json: any): WorkspaceOrganizationSchema {
    return WorkspaceOrganizationSchemaFromJSONTyped(json, false);
}

export function WorkspaceOrganizationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceOrganizationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPersonal': json['is_personal'],
    };
}

export function WorkspaceOrganizationSchemaToJSON(value?: WorkspaceOrganizationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_personal': value.isPersonal,
    };
}

